var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',{staticClass:"tab_with_btn_holder"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Payslip"}},[_c('Payslip')],1),_c('vs-tab',{attrs:{"label":"Payments Settings"}},[_c('Settings')],1)],1),_c('div',{staticClass:"button_like_holder"},[_c('strong',[_vm._v("Next Payment Date")]),_c('p',[_vm._v("Tuesday 15th March, 2022")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }